module.exports = __webpack_public_path__ + "images/places/asm_57-6f7678eb136e077ee2f53451c4706310.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/asm_57.jpg
 ** module id = 309
 ** module chunks = 0
 **/